import { useState } from "react";
import { ArrowUpRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

const FORMSPREE_ID = process.env.REACT_APP_FORMSPREE_ID || "";

const WaitlistForm = ({ variant = "hero" }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setStatus("loading");

    try {
      if (FORMSPREE_ID) {
        const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ email, source: "equallayer-landing" }),
        });
        if (!res.ok) throw new Error("Request failed");
      } else {
        // No Formspree ID configured — simulate success so the form works out of the box.
        await new Promise((r) => setTimeout(r, 650));
      }
      setStatus("success");
      toast.success("You're on the list. We'll be in touch.");
      setEmail("");
      setTimeout(() => setStatus("idle"), 3500);
    } catch {
      setStatus("error");
      toast.error("Something went wrong. Please try again.");
      setTimeout(() => setStatus("idle"), 2500);
    }
  };

  const isHero = variant === "hero";

  return (
    <form
      onSubmit={handleSubmit}
      data-testid={`waitlist-form-${variant}`}
      className={`group relative flex w-full items-center gap-2 rounded-full border transition-all ${
        isHero
          ? "border-white/10 bg-white/[0.04] p-1.5 pl-5 shadow-[0_10px_40px_-15px_rgba(99,102,241,0.4)] focus-within:border-indigo-500/50 focus-within:shadow-[0_10px_60px_-10px_rgba(99,102,241,0.55)]"
          : "border-white/10 bg-white/[0.03] p-1.5 pl-5 focus-within:border-indigo-500/50"
      }`}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@company.com"
        aria-label="Email address"
        data-testid={`waitlist-input-${variant}`}
        className="flex-1 min-w-0 bg-transparent outline-none border-0 text-white placeholder:text-zinc-500 font-body text-[15px] py-2.5"
      />
      <button
        type="submit"
        disabled={status === "loading"}
        data-testid={`waitlist-submit-${variant}`}
        className="inline-flex items-center gap-2 rounded-full bg-indigo-500 hover:bg-indigo-400 disabled:opacity-70 px-5 py-2.5 text-sm font-medium text-white transition-all shadow-[0_0_24px_rgba(99,102,241,0.35)] hover:shadow-[0_0_36px_rgba(99,102,241,0.6)]"
      >
        {status === "loading" && <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2} />}
        {status === "success" && <Check className="h-4 w-4" strokeWidth={2} />}
        {status === "idle" && <ArrowUpRight className="h-4 w-4" strokeWidth={2} />}
        {status === "error" && <ArrowUpRight className="h-4 w-4" strokeWidth={2} />}
        <span>
          {status === "success" ? "Joined" : status === "loading" ? "Joining" : "Join Early Access"}
        </span>
      </button>
    </form>
  );
};

export default WaitlistForm;
